import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'appOverlays';

interface AppOverlaysState {
  switchAccountOverlayOpen: boolean;
}

const initialAppOverlaysState: AppOverlaysState = {
  switchAccountOverlayOpen: false,
};

const _appOverlaysSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialAppOverlaysState,
  reducers: {
    setSwitchAccountOverlayOpen: (state, action: PayloadAction<boolean>) => {
      state.switchAccountOverlayOpen = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = _appOverlaysSlice.reducer;
const actions = _appOverlaysSlice.actions;

const getHomeScreenSectionsState = (rootState: any): AppOverlaysState =>
  rootState[FEATURE_KEY];

const switchAccountOverlayOpenSelector = createSelector(
  getHomeScreenSectionsState,
  (state) => state.switchAccountOverlayOpen
);

export { actions, reducer, switchAccountOverlayOpenSelector };
